import { AD_CONFIG_START, AD_CONFIG_DATA, AD_CONFIG_SAVE, AD_CONFIG_END } from '../type';
import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

type Dispatch = (action: Action) => void;

const API_URL = process.env.REACT_APP_API_URL;

export const getAdConfig = () => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    dispatch({ type: AD_CONFIG_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/ad-configuration`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: AD_CONFIG_DATA, payload: res.data || res, loading: false });
      return { success: true, data: res.data || res };
    } else {
      dispatch({ type: AD_CONFIG_END, payload: res.message, loading: false });
      return { success: false, message: res.message };
    }
  } catch (error: any) {
    dispatch({ type: AD_CONFIG_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};

export const saveAdConfig = (payload: any) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    dispatch({ type: AD_CONFIG_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const body = {
      hostName:      payload.hostName,
      userName:      payload.userName,
      userFullEmail: payload.userFullEmail,
      baseName:      payload.baseName,
      adminPassword: payload.adminPassword,
      portNumber:    Number(payload.portNumber),
      userFull:      payload.userFullEmail,
      mobileNumber:  payload.mobileNumber,
      adminName:     payload.adminName,
      sslAuthType:   payload.sslType,
      redirectURL:   payload.redirectURL,
    };
    const response = await fetch(`${API_URL}/api/ad-configuration`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: AD_CONFIG_SAVE, payload: res.data || res, loading: false });
      return { success: true, message: res.message };
    } else {
      dispatch({ type: AD_CONFIG_END, payload: res.message, loading: false });
      return { success: false, message: res.message };
    }
  } catch (error: any) {
    dispatch({ type: AD_CONFIG_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};

export const testAdConnection = (payload: any) => async (_dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/ad-config/test`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const res = await response.json();
    return response.ok
      ? { success: true, message: res.message || 'Connection successful' }
      : { success: false, message: res.message || 'Connection failed' };
  } catch (error: any) {
    return { success: false, message: error.message };
  }
};
